module.exports = __webpack_public_path__ + "img/textFull.195e577c.png";